var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\xEC\x84\xBC\xEC\x84\x9C/\xEC\x82\xAC\xEC\x9A\xB4\xEB\x93\x9C"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2020_4971",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2020_4971)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "volume_up",
    d: "M15.7051 9.97918C15.7051 8.83168 15.3982 7.78495 14.7843 6.83898C14.1705 5.89287 13.3471 5.18641 12.3141 4.7196C12.1538 4.64377 12.0358 4.5305 11.9599 4.37981C11.8841 4.22925 11.8755 4.07648 11.9343 3.92148C12.0015 3.75273 12.1201 3.63578 12.2899 3.57064C12.4598 3.50536 12.6318 3.51071 12.806 3.58668C14.0624 4.1571 15.068 5.0155 15.8228 6.16189C16.5776 7.30828 16.9549 8.58071 16.9549 9.97918C16.9549 11.3777 16.5776 12.6501 15.8228 13.7965C15.068 14.9429 14.0624 15.8013 12.806 16.3717C12.6318 16.4477 12.4598 16.453 12.2899 16.3877C12.1201 16.3226 12.0015 16.2056 11.9343 16.0369C11.8755 15.8819 11.8841 15.7291 11.9599 15.5786C12.0358 15.4279 12.1538 15.3146 12.3141 15.2388C13.3471 14.772 14.1705 14.0655 14.7843 13.1194C15.3982 12.1734 15.7051 11.1267 15.7051 9.97918ZM6.13784 12.0834H3.79805C3.58332 12.0834 3.40409 12.0115 3.26034 11.8677C3.11673 11.7241 3.04492 11.5449 3.04492 11.33V8.67002C3.04492 8.45516 3.11673 8.27592 3.26034 8.13231C3.40409 7.98856 3.58332 7.91668 3.79805 7.91668H6.13784L8.63138 5.42314C8.8311 5.22342 9.06103 5.17773 9.32117 5.28606C9.58131 5.39453 9.71138 5.59085 9.71138 5.87502V14.125C9.71138 14.4092 9.58131 14.6055 9.32117 14.714C9.06103 14.8223 8.8311 14.7766 8.63138 14.5769L6.13784 12.0834ZM13.4614 10C13.4614 10.5192 13.3535 11.0112 13.1376 11.4761C12.9219 11.9408 12.6308 12.3318 12.2643 12.649C12.1468 12.727 12.0231 12.7345 11.8933 12.6715C11.7635 12.6084 11.6987 12.5043 11.6987 12.359V7.59939C11.6987 7.45412 11.7635 7.34995 11.8933 7.28689C12.0231 7.22384 12.1468 7.23134 12.2643 7.30939C12.6308 7.63523 12.9219 8.0353 13.1376 8.5096C13.3535 8.98405 13.4614 9.48085 13.4614 10Z",
    fill: "#161C24"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSound);
export default __webpack_public_path__ + "static/media/icon_sound.6415704ce497fe4be25cf656c58f021f.svg";
export { ForwardRef as ReactComponent };